<h4 mat-dialog-title>Acquisition: {{ acquisition.label }}</h4>
<button mat-icon-button mat-dialog-close>
  <mat-icon>close</mat-icon>
</button>
<div mat-dialog-content>
  <ng-container *ngIf="!error; else errorState">
    <form [formGroup]="form">
      <span class="field-label">Acquisition Label</span>
      <mat-form-field appearance="outline">
        <input matInput formControlName="label" [attr.readonly]="!permissions.canEditMetadata ? true : null">
        <mat-error *ngIf="form.controls.label.errors?.required"><small>Acquisition label is required.</small></mat-error>
        <mat-error *ngIf="form.controls.label.errors?.maxlength"><small>Acquisition label must not exceed {{ acquisitionLabelMaxLength }} characters.</small></mat-error>
      </mat-form-field>
      <span class="field-action-menu">
        <fw-action-menu [auditable]="acquisition" fieldLabel="Acquisition Label" fieldKey="label"></fw-action-menu>
      </span>
    </form>
    <!-- Custom Information -->
     <info-edit
      [container]="acquisition"
      [writable]="permissions.canEditMetadata"
      [info]="acquisition.info"
      [displaySave]="false"
      [changeManagerEnabled]="false"
      class="animated fadeInLeft">
    </info-edit>

    <fw-tags
      *ngIf="permissions.viewTags"
      [container]="acquisition"
      (afterSave)="acquisition.tags = $event">
  </fw-tags>

  </ng-container>
  <ng-template #errorState>
    <div class="info-message">
      <div class="fab">
        <mat-icon>error_outline</mat-icon>
      </div>
      <ng-container [ngSwitch]="$any(error).status">
        <p *ngSwitchCase="404">{{ acquisition.label }} does not exist.</p>
        <ng-container *ngSwitchDefault>
          <p>{{ acquisition.label }} data could not be loaded.</p>
          <button mat-flat-button (click)="getAcquisition()" color="primary">Try Again</button>
        </ng-container>
      </ng-container>
    </div>
  </ng-template>
</div>
<div mat-dialog-actions align="end">
  <button mat-stroked-button color="primary" (click)="close()" test-id="acquisition-info-close">
    Close
  </button>
  <button mat-flat-button color="primary" test-id="acquisition-info-submit" (click)="save()" [disabled]="!form.valid">
    Save
  </button>
</div>
